import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
// import Datetime from 'react-datetime'
import { isEqual } from 'lodash'

// Actions
import { setOrdersFilter, resetFilter, resetSimplesearch, setSimplesearch, setOrdersSearch } from '../../../../actions/orders'
import { getAgreementConstraints } from '../../../../actions/agreementConstraint'
import { getCustomerGroups } from '../../../../actions/customerGroup'

// import styles
import './searchfilter.scss'

// import components
import InputState from '../../InputState'

// import utils
import { hasSubscriptionPermission, hasAccess } from '../../../../utils/auth'
import { translation } from '../../../../utils/helpers'
import { getOrderFilterData } from '../../../../utils/filter'

import { OrderDepartmentIcons } from '../../../elements/icons'

// Elements
import Text from '../../../elements/text'
import Button from '../../../elements/button'
import Inline from '../../../elements/inline'
import DropDown from '../../../elements/dropDown'
import DateTime from '../../../elements/datetime'
import Check from '../../../elements/check'
import Switch from '../../../elements/switch'
// import PageHeader from '../../../elements/pageHeader'
import Icon from '../../../elements/icon'
import LabelWrapper from '../../../elements/labelWrapper'

class SearchFilter extends Component {

  constructor (props) {
    super(props)
    this.state = {
      isOpen: false,
      filter: {},
      simplesearch: {
        save: true,
        value: ''
      },
      customergroups: [],
      pricemodels: []
    }

    // Bind to this
    this.onChange = this.onChange.bind(this)
    this.renderProcessStep = this.renderProcessStep.bind(this)
    this.renderEvaluation = this.renderEvaluation.bind(this)
    this.renderUpdate = this.renderUpdate.bind(this)
    this.renderOrderType = this.renderOrderType.bind(this)
    this.renderDelivery = this.renderDelivery.bind(this)
    this.renderVehicleData = this.renderVehicleData.bind(this)
    this.renderColor = this.renderColor.bind(this)
    this.renderInvoice = this.renderInvoice.bind(this)
    this.renderSpareParts = this.renderSpareParts.bind(this)
    this.renderIdentification = this.renderIdentification.bind(this)

    this.advancedSearchForm = this.advancedSearchForm.bind(this)
    this.simpleSearchForm = this.simpleSearchForm.bind(this)
    this.handleInputState = this.handleInputState.bind(this)
    this.openFilterTab = this.openFilterTab.bind(this)
    this.triggerSearch = this.triggerSearch.bind(this)
    this.renderCustomerGroup = this.renderCustomerGroup.bind(this)
    this.resetFilter = this.resetFilter.bind(this)
    this.resetSimplesearch = this.resetSimplesearch.bind(this)
    this.getAgreementConstraints = this.getAgreementConstraints.bind(this)
    this.getCustomerGroups = this.getCustomerGroups.bind(this)
    this.renderEconomicFilter = this.renderEconomicFilter.bind(this)
    this.renderDepartmentType = this.renderDepartmentType.bind(this)
    this.renderAdditionalReport = this.renderAdditionalReport.bind(this)
  }

  componentDidMount () {
    this.getAgreementConstraints()
    this.getCustomerGroups()
    // console.log('mount')
    this.getOrSetFilter()
  }

  getOrSetFilter () {
    // let filter = { ...this.props.filter }
    // console.log('getfilter this.props.source', this.props.source)
    const { source, filter, simpleSearch } = getOrderFilterData(this.props)
    // let source = 'orderlist'
    // if (hasAccess([4], this.props.auth.user.UserType)) {
    //   source = 'customer'
    // } else if (hasAccess([6], this.props.auth.user.UserType)) {
    //   source = 'wp'
    // } else if (this.props.source === 'workscreen') {
    //   source = 'workscreen'
    // }

    // // get filter from local storage if no filter active/ refresh page
    // if (isEqual(this.props.filter, this.props.initialFilter)) {
    //   let storedFilter = JSON.parse(window.localStorage.getItem('filterOrderlist'))
    //   console.log('getfilter isEqual props.filter and this.props.initialFilter ')
    //   if (hasAccess([4], this.props.auth.user.UserType)) {
    //     storedFilter = JSON.parse(window.localStorage.getItem('filterCustomer'))
    //   } else if (hasAccess([6], this.props.auth.user.UserType)) {
    //     storedFilter = JSON.parse(window.localStorage.getItem('filterWP'))
    //   } else if (this.props.source === 'workscreen') {
    //     storedFilter = JSON.parse(window.localStorage.getItem('filterWorkscreen'))
    //   }
    //   if (storedFilter !== undefined && storedFilter !== null && storedFilter.delivery !== undefined) {
    //     filter = storedFilter
    //   }
    // }

    // // Final check to make sure we have a filter
    // if (filter === undefined || filter === null || isEqual(filter, { NewOrdersFilter: 0 })) {
    //   filter = this.props.initialFilter
    // }
    // // console.log('Workscreen filter', filter)

    // // get simple search from local storage if none active/ page refresh
    // let simpleSearch = this.props.simplesearch
    // if (simpleSearch !== undefined && simpleSearch !== null && simpleSearch.value !== undefined && simpleSearch.value.length === 0) {
    //   let storedSimpleSearch = ''
    //   if (this.props.source === 'workscreen') {
    //     storedSimpleSearch = JSON.parse(window.localStorage.getItem('simplesearchWorkscreen'))
    //   } else {
    //     storedSimpleSearch = JSON.parse(window.localStorage.getItem('simpleSearch'))
    //     console.log('getfilter storedSimpleSearch', storedSimpleSearch)
    //   }
    //   if (storedSimpleSearch !== '') {
    //     simpleSearch = storedSimpleSearch
    //   }
    // }

    // if simplesearch save is set, reset filter and use search values
    if (simpleSearch !== undefined && simpleSearch !== null && simpleSearch.value !== undefined && simpleSearch.value.length > 0) {
      resetFilter(source)
      setTimeout(() => {
        let newFilter = JSON.parse(JSON.stringify(this.props.initialFilter))
        if (!hasAccess([4], this.props.auth.user.UserType)) {
          newFilter.process.Completed = false
          newFilter.process.CompletedThisWeek = true
        }
        this.props.setOrdersFilter(newFilter, source)
        setTimeout(() => {
          this.props.onSubmit({
            SimpleSearch: simpleSearch.value,
            SkipCheck: true,
            movedOrders: true
          })
          if (this.refs.simplesearch !== undefined && this.refs.simplesearch.refs.input !== undefined) {
            // console.log('this.refs.simplesearch', this.refs.simplesearch.refs.input)
            // this.refs.simplesearch.refs.input.value = simpleSearch.refs.input.value
            this.refs.simplesearch.refs.input.value = simpleSearch.value
          }
        }, 50)
      }, 50)
    } else {
      if (hasAccess([4], this.props.auth.user.UserType)) {
        // filter.process.Completed = false
        // filter.process.CompletedThisWeek = false
      }
      if (hasAccess([6], this.props.auth.user.UserType) && window.localStorage.getItem('get-drafts-as-wp') !== 'true') {
        filter.process.draft2 = false
        filter.process.draft1 = false
        filter.process.draft = false
      }

      this.setState({
        filter: filter,
        simplesearch: simpleSearch
      })
    }

    if (this.props.auth.user.UserId !== parseInt(window.localStorage.getItem('auth-user-UserId')) && this.props.router.location.pathname === '/orders') {
      // console.log('reset filter - other user')
      window.localStorage.setItem('auth-user-UserId', this.props.auth.user.UserId)
      resetFilter(source)
      setTimeout(() => {
        let newFilter = JSON.parse(JSON.stringify(this.props.initialFilter))
        if (!hasAccess([4], this.props.auth.user.UserType)) {
          newFilter.process.Completed = false
          newFilter.process.CompletedThisWeek = true
        }
        this.props.setOrdersFilter(newFilter, source)
        setTimeout(() => {
          this.props.onSubmit(newFilter)
        }, 50)
      }, 50)
    }
  }

  getAgreementConstraints () {
    if (!hasAccess([6], this.props.auth.user.UserType)) return
    this.props.getAgreementConstraints(this.props.auth.user.WorkProviderId).then((res) => {
      let pricemodels = res.data
      this.setState({
        pricemodels: pricemodels
      })
    })
  }
  getCustomerGroups () {
    if (!hasAccess([6], this.props.auth.user.UserType)) return
    this.props.getCustomerGroups().then((res) => {
      let customergroups = res.data
      this.setState({
        customergroups: customergroups
      })
    })
  }
  componentWillReceiveProps (nextProps) {
    // let filter = { ...nextProps.filter }
    const { filter, simpleSearch } = getOrderFilterData(this.props)
    // if (hasAccess([4], this.props.auth.user.UserType)) {
    //   // filter.process.Completed = false
    // }
    this.setState({
      filter: filter,
      simplesearch: simpleSearch
    })
  }

  openFilterTab (e) {
    // console.log('SearchFilter -> openFilterTab')
    let parent = e.target.parentNode
    while (true) {
      if (parent.tagName.toLowerCase() !== 'li') {
        parent = parent.parentNode
        continue
      }
      break
    }
    if (parent.className !== 'open') {
      parent.className = 'open'
    } else {
      parent.className = ''
    }
  }

  handleInputState (option, name) {
    name = name.split('_')
    if (name.length > 1) {
      this.setState({
        filter: {
          ...this.state.filter,
          [name[0]]: {
            ...this.state.filter[name[0]],
            [name[1]]: {
              ...this.state.filter[name[0]][name[1]],
              option: option
            }
          }
        }
      }, () => {
        // console.log(this.state.filter.process)
      })
    } else {
      this.setState({
        filter: {
          ...this.state.filter,
          [name[0]]: {
            ...this.state.filter[name[0]],
            option: option
          }
        }
      }, () => {
        // console.log(this.state.filter.process)
      })
    }
  }

  onChange (e) {
    // console.log(this.state.filter.process, e)
    let name = ''
    // console.log('e.target, name, value ', e.target, e.target.name, e.target.value)
    switch (e.target.name) {
      case 'simplesearch_save':
        this.setState({
          simplesearch: {
            ...this.state.simplesearch,
            save: e.target.checked
          }
        })
        break
      case 'order_process':
        this.setState({
          filter: {
            ...this.state.filter,
            process: {
              step: e.target.value,
              draft: this.state.filter.process.draft
            }
          }
        })
        break
      case 'order_process_InProcess':
      case 'order_process_Completed':
      case 'order_process_CompletedThisWeek':
      case 'order_process_draft':
      case 'order_process_draft1':
      case 'order_process_draft2':
        name = e.target.name.split('_')[2]
        if (hasAccess([6], this.props.auth.user.UserType) && e.target.name === 'order_process_draft') {
          window.localStorage.setItem('get-drafts-as-wp', e.target.checked ? 'true' : 'false')
          this.setState({
            filter: {
              ...this.state.filter,
              process: {
                ...this.state.filter.process,
                [name]: e.target.checked,
                draft1: e.target.checked,
                draft2: e.target.checked
              }
            }
          }, () => {
            // console.log('state', this.state.filter.process)
          })
        } else {
          this.setState({
            filter: {
              ...this.state.filter,
              process: {
                ...this.state.filter.process,
                [name]: e.target.checked
              }
            }
          }, () => {
            // console.log('state', this.state.filter.process)
          })
        }
        break
      case 'order_evaluation[]':
        let evaluation = Object.assign({}, this.state.filter.evaluation)
        if (e.target.checked) {
          evaluation[e.target.value] = true
        } else {
          evaluation[e.target.value] = false
        }
        this.setState({
          filter: {
            ...this.state.filter,
            evaluation: evaluation
          }
        })
        break
      case 'order_update[]':
        let update = Object.assign({}, this.state.filter.update)
        if (e.target.checked) {
          update[e.target.value] = true
        } else {
          update[e.target.value] = false
        }
        this.setState({
          filter: {
            ...this.state.filter,
            update: update
          }
        })
        break
      case 'order_invoice[]':
        let invoice = Object.assign({}, this.state.filter.invoice)
        if (e.target.checked) {
          invoice[e.target.value] = true
        } else {
          invoice[e.target.value] = false
        }
        this.setState({
          filter: {
            ...this.state.filter,
            invoice: invoice
          }
        })
        break

      case 'parts':
        let parts = Object.assign({}, this.state.filter.parts)
        if (e.target.checked) {
          parts[e.target.value] = true
        } else {
          parts[e.target.value] = false
        }
        this.setState({
          filter: {
            ...this.state.filter,
            parts: parts
          }
        })
        break
      case 'ordertype':
        this.setState({
          filter: {
            ...this.state.filter,
            orderType: e.target.value
          }
        })
        break
      case 'delivery_transport':
        this.setState({
          filter: {
            ...this.state.filter,
            delivery: {
              ...this.state.filter.delivery,
              transport: e.target.value
            }
          }
        })
        break
      case 'pricemodel_pricemodelid':
        let value = e.target.value
        if (e.target.value === '-1') {
          this.setState({
            filter: {
              ...this.state.filter,
              pricemodel: undefined
            },
            selectedpricemodel: -1
          })
        } else {
          let constraint = this.state.pricemodels.find((val) => Number(val.AgreementConstraintId) === Number(value))
          let id = constraint.Name
          this.setState({
            filter: {
              ...this.state.filter,
              pricemodel: {
                ...this.state.filter.pricemodel,
                PriceModelName: id,
                PriceModelId: value
              }
            },
            selectedpricemodel: value
          }, () => {
            // console.log(this.state, value)
          })
        }
        break
      case 'customergroup_customergroupid':
        let valu = e.target.value
        if (valu === '-1') {
          this.setState({
            filter: {
              ...this.state.filter,
              customergroup: undefined
            },
            selectedcustomergroup: -1
          })
        } else {
          let id = this.state.customergroups.find((val) => Number(val.CustomerGroupId) === Number(valu)).Name
          this.setState({
            filter: {
              ...this.state.filter,
              customergroup: {
                ...this.state.filter.customergroup,
                CustomerGroupName: id,
                CustomerGroupId: valu
              }
            },
            selectedcustomergroup: valu
          }, () => {
            // console.log(valu, id, this.state)
          })
        }

        break
      case 'delivery_delivery_start':
      case 'delivery_delivery_end':
      case 'delivery_pickup_start':
      case 'delivery_pickup_end':
      case 'delivery_production_start':
      case 'delivery_production_end':
        name = e.target.name.split('_')
        this.setState({
          filter: {
            ...this.state.filter,
            delivery: {
              ...this.state.filter.delivery,
              [name[1]]: {
                ...this.state.filter.delivery[name[1]],
                [name[2]]: e.target.value
              }
            }
          }
        })
        break
      case 'vehicle_regnumber':
      case 'vehicle_brand':
      case 'vehicle_model':
      case 'vehicle_year':
      case 'color_color':
      case 'color_code':
      case 'color_ctype':
      case 'identification_ordernumber':
      case 'identification_rekvnumber':
        name = e.target.name.split('_')
        this.setState({
          filter: {
            ...this.state.filter,
            [name[0]]: {
              ...this.state.filter[name[0]],
              [name[1]]: {
                ...this.state.filter[name[0]][name[1]],
                value: e.target.value
              }
            }
          }
        })
        break
      case 'order_economicfilter[]':
        let economicfilter = Object.assign({}, this.state.filter.economicfilter)
        if (e.target.checked) {
          economicfilter[e.target.value] = true
        } else {
          economicfilter[e.target.value] = false
        }
        this.setState({
          filter: {
            ...this.state.filter,
            economicfilter: economicfilter
          }
        })
        break
      case 'order_additionalreport[]':
        let additionalreport = Object.assign({}, this.state.filter.additionalreport)
        if (e.target.checked) {
          additionalreport[e.target.value] = true
        } else {
          additionalreport[e.target.value] = false
        }
        this.setState({
          filter: {
            ...this.state.filter,
            additionalreport: additionalreport
          }
        })
        break
    }
  }

  itemLayout (title, content, active) {
    let activeClass = ''
    if (active) {
      activeClass = 'active'
    }
    return (
      <li>
        <div className={'title ' + activeClass} onClick={this.openFilterTab}>{title} <i className='fa fa-plus' /></div>
        <ul>
          {content}
        </ul>
      </li>
    )
  }

  checkActiveState (name) {
    let initialFilter = { ...this.props.initialFilter }
    if (hasAccess([4], this.props.auth.user.UserType)) {
      initialFilter.process.Completed = false
      initialFilter.process.CompletedThisWeek = false
    } else {
      initialFilter.process.Completed = false
      // initialFilter.process.CompletedThisWeek = true // This should be handled by reducer
    }
    if (hasAccess([6], this.props.auth.user.UserType)) {
      initialFilter.process.draft1 = false
      initialFilter.process.draft2 = false
      initialFilter.process.draft = false
    }
    let checker = this.state.filter[name]
    if (typeof checker === 'object') {
      let checkState = JSON.parse(JSON.stringify(initialFilter[name]))
      if (this.props.auth.user.CustomerId !== '-1') {
        if (typeof checkState['external_control'] !== 'undefined' || typeof checker['external_control'] !== 'undefined') {
          delete checkState['external_control']
          delete checker['external_control']
        }
        if (typeof checkState['invoicing'] !== 'undefined' || typeof checker['invoicing'] !== 'undefined') {
          delete checkState['invoicing']
          delete checker['invoicing']
        }
        if (typeof checkState['customer'] !== 'undefined' || typeof checker['customer'] !== 'undefined') {
          delete checkState['customer']
          delete checker['customer']
        }
        if (name === 'update') {
          delete checkState['missing']
          delete checker['missing']
        }
        if (name === 'delivery') {
          delete checkState['production']
          delete checker['production']
        }
        if (name === 'color') {
          delete checkState['amount']
          delete checker['amount']
        }
      }
      return !isEqual(checkState, checker)
    } else {
      let checkState = initialFilter[name]
      if (name === 'customergroup_customergroupid') {
        return this.state.filter.customergroup !== undefined && this.state.filter.customergroup.CustomerGroupId !== -1
      }
      if (name === 'pricemodel_pricemodelid') {
        return this.state.filter.pricemodel !== undefined && this.state.filter.pricemodel.PriceModelId !== -1
      }
      if (name === 'orderType') {
        return Number(this.state.filter.orderType) !== 0
      }
      return !checker === checkState
    }
  }

  renderCustomerGroup () {
    let customergroups = this.state.customergroups
    let selectedcustomergroup = -1
    if (this.state.filter.customergroup !== undefined) {
      selectedcustomergroup = this.state.filter.customergroup.CustomerGroupId
    }
    let stepContent = (
      <DropDown value={selectedcustomergroup} name='customergroup_customergroupid' onChange={this.onChange}>
        <option value='-1' key='-1'>{translation('12310')}</option>
        {
          customergroups !== null && customergroups.length > 0 && customergroups.map((val, i) => {
            return (<option value={val.CustomerGroupId} key={val.CustomerGroupId}>{val.Name}</option>)
          })
        }
      </DropDown>
    )
    // console.log(this.state, this.props)
    return this.itemLayout(translation('12282'), stepContent, this.checkActiveState('customergroup_customergroupid'))
  }
  renderPriceModel () {
    // let priceModels = this.state.pricemodels.map((val) => { return val.Name }).filter((value, index, self) => self.indexOf(value) === index)
    let pricemodelsList = this.state.pricemodels
    let grouping = []
    for (let i = 0; i < pricemodelsList.length; i++) {
      let group = grouping.find((val, idx) => { return val.customerGroupName === pricemodelsList[i].CustomerGroupName })
      if (group === undefined) {
        group = {
          customerGroupName: pricemodelsList[i].CustomerGroupName,
          pricemodelsList: []
        }
        grouping.push(group)
      }
      group.pricemodelsList.push(pricemodelsList[i])
      group.pricemodelsList.sort((a, b) => a.Name.localeCompare(b.Name))
    }
    grouping.sort((a, b) => a.customerGroupName.localeCompare(b.customerGroupName))
    const renderGroup = (group, key) => {
      const renderItem = (val, key) => {
        if (val.PriceType === 8) return null
        return (<option value={val.AgreementConstraintId} key={val.AgreementConstraintId}>{val.Name}</option>)
      }
      let customerGroupName = group.customerGroupName
      return (
        <optgroup label={customerGroupName} key={customerGroupName}>
          {group.pricemodelsList.map(renderItem)}
        </optgroup>
      )
    }
    let selectedPriceModel = -1
    if (this.state.filter.pricemodel !== undefined) {
      selectedPriceModel = this.state.filter.pricemodel.PriceModelId
    }
    let stepContent = (
      <DropDown name='pricemodel_pricemodelid' onChange={this.onChange} value={selectedPriceModel} isGrouping>
        <option value='-1' key='-1'>{translation('12311')}</option>
        {grouping.map(renderGroup)}
      </DropDown>
    )
    return this.itemLayout(translation('12270'), stepContent, this.checkActiveState('pricemodel_pricemodelid'))
  }
  renderProcessStep () {
    if (this.props.disableProcessStep) return null
    let stepContent = (
      <div>
        <Check labelText={translation('13366')} id='order_process-draft' name='order_process_draft' onChange={this.onChange} checked={this.state.filter.process.draft} />
        <Check labelText={translation('208')} id='order_process-inprocess' name='order_process_InProcess' onChange={this.onChange} checked={this.state.filter.process.InProcess} />
        <Check labelText={translation('2702')} id='order_process-completed-this-week' name='order_process_CompletedThisWeek' onChange={this.onChange} checked={this.state.filter.process.CompletedThisWeek} />
        <Check labelText={translation('2703')} id='order_process-completed' name='order_process_Completed' onChange={this.onChange} checked={this.state.filter.process.Completed} />
      </div>
    )
    if (!hasAccess([4, 6], this.props.auth.user.UserType)) {
      stepContent = (
        <div>
          <Check labelText={translation('13496')} id='order_process-draft1' name='order_process_draft1' onChange={this.onChange} checked={this.state.filter.process.draft1} />
          <Check labelText={translation('13497')} id='order_process-draft2' name='order_process_draft2' onChange={this.onChange} checked={this.state.filter.process.draft2} />
          <Check labelText={translation('208')} id='order_process-inprocess' name='order_process_InProcess' onChange={this.onChange} checked={this.state.filter.process.InProcess} />
          <Check labelText={translation('2702')} id='order_process-completed-this-week' name='order_process_CompletedThisWeek' onChange={this.onChange} checked={this.state.filter.process.CompletedThisWeek} />
          <Check labelText={translation('2703')} id='order_process-completed' name='order_process_Completed' onChange={this.onChange} checked={this.state.filter.process.Completed} />
        </div>
      )
    }
    return this.itemLayout(translation('946'), stepContent, this.checkActiveState('process'))
  }

  renderEvaluation () {
    let stepContent = (
      <div>
        <Check labelText={translation('13367')} value='missing' id='order_evaluation-1' name='order_evaluation[]' onChange={this.onChange} checked={this.state.filter.evaluation.missing} />
        <Check labelText={translation('13368')} value='evaluated' id='order_evaluation-2' name='order_evaluation[]' onChange={this.onChange} checked={this.state.filter.evaluation.evaluated} />
      </div>
    )
    return this.itemLayout(translation('13363'), stepContent, this.checkActiveState('evaluation'))
  }

  renderUpdate () {
    let missingUpdate = ''
    if (this.props.auth.user.CustomerId === '-1') {
      missingUpdate = (
        <Check labelText={translation('13369')} value='missing' id='order_update-1' name='order_update[]' onChange={this.onChange} checked={this.state.filter.update.missing} />
      )
    }
    let stepContent = (
      <div>
        {missingUpdate}
        <Check labelText={translation('950')} value='updated' id='order_update-2' name='order_update[]' onChange={this.onChange} checked={this.state.filter.update.updated} />
      </div>
    )
    return this.itemLayout(translation('998'), stepContent, this.checkActiveState('update'))
  }

  renderInvoice () {
    if (hasAccess([4], this.props.auth.user.UserType)) return null
    let invoiceName = hasAccess([6], this.props.auth.user.UserType) ? '13002' : '529'
    let stepContent = (
      <div>
        <Check labelText={translation('1140')} value='notApprovedForInvoicing' id='order_invoice-3' name='order_invoice[]' onChange={this.onChange} checked={this.state.filter.invoice.notApprovedForInvoicing} />
        <Check labelText={translation('1139')} value='approvedForInvoicing' id='order_invoice-1' name='order_invoice[]' onChange={this.onChange} checked={this.state.filter.invoice.approvedForInvoicing} />
        <Check labelText={translation(invoiceName)} value='isInvoiced' id='order_invoice-2' name='order_invoice[]' onChange={this.onChange} checked={this.state.filter.invoice.isInvoiced} />
        {hasAccess([6], this.props.auth.user.UserType) && (
          <Check labelText={translation('13003')} value='isInvoicedByWP' id='order_invoice-4' name='order_invoice[]' onChange={this.onChange} checked={this.state.filter.invoice.isInvoicedByWP} />
        )}
      </div>
    )
    return this.itemLayout(translation('13486'), stepContent, this.checkActiveState('invoice'))
  }

  renderAdditionalReport () {
    let isCustomer = this.props.auth.user.DepartmentType === 1 || hasAccess([4], this.props.auth.user.UserType)
    let headingText = '937'
    let awaitingText = '14915'
    let additionalreportText = '14916'
    if (isCustomer) {
      headingText = '14921'
      awaitingText = '14922'
      additionalreportText = '14923'
    }
    let stepContent = (
      <div>
        <Check labelText={translation(awaitingText)} value='awaiting' id='order_additionalreport-1' name='order_additionalreport[]' onChange={this.onChange} checked={this.state.filter.additionalreport.awaiting} />
        <Check labelText={translation(additionalreportText)} value='received' id='order_additionalreport-2' name='order_additionalreport[]' onChange={this.onChange} checked={this.state.filter.additionalreport.received} />
      </div>
    )
    return this.itemLayout(translation(headingText), stepContent, this.checkActiveState('additionalreport'))
  }

  renderEconomicFilter () {
    if (hasAccess([4], this.props.auth.user.UserType)) return null
    let { economicfilter } = this.state.filter
    let filterNotMatched = economicfilter.economicFilterNotMatched !== undefined ? economicfilter.economicFilterNotMatched : false
    let filterMatched = economicfilter.economicFilterMatched !== undefined ? economicfilter.economicFilterMatched : false
    let stepContent = (
      <div>
        <Check labelText={translation('14809')} value='economicFilterNotMatched' id='order_economicfilter-1' name='order_economicfilter[]' onChange={this.onChange} checked={filterNotMatched} />
        <Check labelText={translation('14808')} value='economicFilterMatched' id='order_economicfilter-2' name='order_economicfilter[]' onChange={this.onChange} checked={filterMatched} />
      </div>
    )
    return this.itemLayout(translation('14807'), stepContent, this.checkActiveState('economicfilter'))
  }

  renderSpareParts () {
    let stepContent = (
      <div>
        <LabelWrapper labelText={translation('161')}>
          <Check labelText={translation('14796')} value='paintNotOrdered' id='parts-1' name='parts' onChange={this.onChange} checked={this.state.filter.parts.paintNotOrdered} />
          <Check labelText={translation('16535')} value='paintOrdered' id='parts-2' name='parts' onChange={this.onChange} checked={this.state.filter.parts.paintOrdered} />
          <Check labelText={translation('16452')} value='paintArrived' id='parts-4' name='parts' onChange={this.onChange} checked={this.state.filter.parts.paintArrived} />
        </LabelWrapper>
        <LabelWrapper labelText={translation('14779')}>
          <Check labelText={translation('14796')} value='bodyNotOrdered' id='parts-5' name='parts' onChange={this.onChange} checked={this.state.filter.parts.bodyNotOrdered} />
          <Check labelText={translation('16535')} value='bodyOrdered' id='parts-6' name='parts' onChange={this.onChange} checked={this.state.filter.parts.bodyOrdered} />
          <Check labelText={translation('16452')} value='bodyArrived' id='parts-8' name='parts' onChange={this.onChange} checked={this.state.filter.parts.bodyArrived} />
        </LabelWrapper>
      </div>
    )
    return this.itemLayout(translation('637'), stepContent, this.checkActiveState('parts'))
  }

  renderOrderType () {
    let stepContent = (
      <DropDown value={this.state.filter.orderType} onChange={this.onChange} name='ordertype'>
        <option value='0'>{translation('13401')}</option>
        {Object.keys(this.props.orderTypes).map((val, index) => {
          return (
            <option key={index} value={val}>{translation(this.props.orderTypes[val])}</option>
          )
        })}
      </DropDown>
    )
    return this.itemLayout(translation('525'), stepContent, this.checkActiveState('orderType'))
  }

  renderDatepicker (name, stateName1, stateName2, alignDatePickerRight = false) {
    if (typeof this.state.filter.delivery[stateName1] === 'undefined') return null

    let date = ''
    let val = this.state.filter.delivery[stateName1][stateName2]

    let translationArr = {
      start: '188',
      end: '187'
    }

    let showTime = false
    let closeOnSelect = true
    let inputProps = {
      name: name,
      placeholder: translation(translationArr[stateName2]),
      readOnly: true
    }
    if (val !== null && val !== '') {
      date = window.CustomDate(val)
    }
    // Input change
    const onInputChange = (datetime) => {
      this.setState({
        filter: {
          ...this.state.filter,
          delivery: {
            ...this.state.filter.delivery,
            [stateName1]: {
              ...this.state.filter.delivery[stateName1],
              [stateName2]: datetime
            }
          }
        }
      })
    }
    const alignCalendar = () => {
      let element = document.querySelector('.rdtOpen').querySelector('.rdtPicker')
      let bounding = element.getBoundingClientRect()

      // out of screen to right
      let windowWidth = parseInt(window.innerWidth)
      let outOfScreen = windowWidth - (bounding.left + bounding.width)
      outOfScreen -= 5

      // scroll bar width
      let appWidth = document.querySelector('#app').getBoundingClientRect().width
      let layoutWidth = document.querySelector('.layout__content').getBoundingClientRect().width
      let scrollBarWidth = appWidth - layoutWidth

      if (outOfScreen < 0) {
        outOfScreen *= -1
        outOfScreen += scrollBarWidth
        element.style.marginLeft = element.style.marginLeft - outOfScreen
      }
    }
    // Render
    return <DateTime
      inputProps={inputProps}
      dateFormat='DD-MM-YYYY'
      timeFormat={showTime}
      closeOnSelect={closeOnSelect}
      value={date}
      onFocus={alignCalendar}
      onChange={onInputChange}
      alignDatePickerRight={alignDatePickerRight} />
  }

  renderDelivery () {
    let showProduction = ''
    if (this.props.auth.user.CustomerId === '-1' && hasSubscriptionPermission(this.props.auth, 10, 13)) {
      showProduction = (
        <LabelWrapper labelText={translation('13402')}>
          <Inline>
            {this.renderDatepicker('delivery_production_start', 'production', 'start', true)}
            {this.renderDatepicker('delivery_production_end', 'production', 'end', true)}
          </Inline>
        </LabelWrapper>
      )
    }
    let stepContent = (
      <li>
        <LabelWrapper labelText={translation('193')}>
          <Inline>
            {this.renderDatepicker('delivery_delivery_start', 'delivery', 'start', true)}
            {this.renderDatepicker('delivery_delivery_end', 'delivery', 'end', true)}
          </Inline>
        </LabelWrapper>
        {showProduction}
        <LabelWrapper labelText={translation('157')}>
          <Inline>
            {this.renderDatepicker('delivery_pickup_start', 'pickup', 'start', true)}
            {this.renderDatepicker('delivery_pickup_end', 'pickup', 'end', true)}
          </Inline>
        </LabelWrapper>
        <DropDown labelText={translation('13371')} value={this.state.filter.delivery.transport} onChange={this.onChange} name='delivery_transport'>
          <option value='0'>{translation('13401')}</option>
          <option value='1'>{translation('154')}</option>
          <option value='2'>{translation('351')}</option>
          <option value='3'>{translation('26')}</option>
        </DropDown>
      </li>
    )
    return this.itemLayout(translation('193'), stepContent, this.checkActiveState('delivery'))
  }

  renderIdentification () {
    let stepContent = (
      <div>
        <InputState placeholder={translation('294')} triggerChange={this.onChange} triggerHandler={this.handleInputState} triggerName='identification_ordernumber' option={this.state.filter.identification.ordernumber.option} value={this.state.filter.identification.ordernumber.value} />
        <InputState placeholder={translation('80')} triggerChange={this.onChange} triggerHandler={this.handleInputState} triggerName='identification_rekvnumber' option={this.state.filter.identification.rekvnumber.option} value={this.state.filter.identification.rekvnumber.value} />
      </div>
    )
    return this.itemLayout(translation('13370'), stepContent, this.checkActiveState('identification'))
  }

  renderVehicleData () {
    let stepContent = (
      <div>
        <InputState placeholder={translation('78')} triggerChange={this.onChange} triggerHandler={this.handleInputState} triggerName='vehicle_regnumber' option={this.state.filter.vehicle.regnumber.option} value={this.state.filter.vehicle.regnumber.value} />
        <InputState placeholder={translation('145')} triggerChange={this.onChange} triggerHandler={this.handleInputState} triggerName='vehicle_brand' option={this.state.filter.vehicle.brand.option} value={this.state.filter.vehicle.brand.value} />
        <InputState placeholder={translation('146')} triggerChange={this.onChange} triggerHandler={this.handleInputState} triggerName='vehicle_model' option={this.state.filter.vehicle.model.option} value={this.state.filter.vehicle.model.value} />
        <InputState placeholder={translation('148')} triggerChange={this.onChange} triggerHandler={this.handleInputState} triggerName='vehicle_year' option={this.state.filter.vehicle.year.option} value={this.state.filter.vehicle.year.value} />
      </div>
    )
    return this.itemLayout(translation('77'), stepContent, this.checkActiveState('vehicle'))
  }

  renderColor () {
    let stepContent = (
      <div>
        <InputState placeholder={translation('179')} triggerChange={this.onChange} triggerHandler={this.handleInputState} triggerName='color_color' option={this.state.filter.color.color.option} value={this.state.filter.color.color.value} />
        <InputState placeholder={translation('13372')} triggerChange={this.onChange} triggerHandler={this.handleInputState} triggerName='color_code' option={this.state.filter.color.code.option} value={this.state.filter.color.code.value} />
        <InputState placeholder={translation('332')} triggerChange={this.onChange} triggerHandler={this.handleInputState} triggerName='color_ctype' option={this.state.filter.color.ctype.option} value={this.state.filter.color.ctype.value} />
      </div>
    )
    return this.itemLayout(translation('179'), stepContent, this.checkActiveState('color'))
  }

  advancedSearchForm (e) {
    e.preventDefault()

    let { filter } = this.state
    // console.log('advancedSearchForm', filter)
    // IF user is a customer, remove some data
    if (this.props.auth.user.CustomerId !== '-1') {
      delete filter['external_control']
      delete filter['invoicing']
      delete filter['customer']
      delete filter['update']['missing']
      delete filter['delivery']['production']
      delete filter['color']['amount']
    }
    if (this.props.disableProcessStep) {
      filter.process.draft = false
      filter.process.InProcess = true
      filter.process.Completed = false
      filter.process.CompletedThisWeek = false
    }

    let source = 'orderlist'
    if (hasAccess([4], this.props.auth.user.UserType)) {
      source = 'customer'
    } else if (hasAccess([6], this.props.auth.user.UserType)) {
      source = 'wp'
    } else if (this.props.source === 'workscreen') {
      source = 'workscreen'
    }

    // console.log('setOrdersFilter', filter)
    this.props.resetSimplesearch(source)
    this.props.setOrdersFilter(filter, source)
    setTimeout(() => {
      this.props.onSubmit(filter)
      this.refs.simplesearch.refs.input.value = ''
    }, 50)
  }

  simpleSearchForm (e) {
    // console.log('simpleSearchForm', this.state.simplesearch)
    e.preventDefault()
    let value = this.refs.simplesearch.refs.input.value
    this.props.onSimple(value)

    let source = 'orderlist'
    if (this.props.source === 'workscreen') {
      source = 'workscreen'
    }

    this.props.setSimplesearch({
      save: this.state.simplesearch.save,
      value: value
    }, source)

    if (!this.state.simplesearch.save) {
      this.refs.simplesearch.refs.input.value = ''
    }

    this.props.resetFilter(source)
    // console.log('this.state.simplesearch.save', this.state.simplesearch.save)
  }

  triggerSearch () {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  resetFilter (e) {
    e.preventDefault()
    let source = 'orderlist'
    if (hasAccess([4], this.props.auth.user.UserType)) {
      source = 'customer'
    } else if (hasAccess([6], this.props.auth.user.UserType)) {
      source = 'wp'
    } else if (this.props.source === 'workscreen') {
      source = 'workscreen'
    }
    this.props.resetFilter(source)
    setTimeout(() => {
      let newFilter = JSON.parse(JSON.stringify(this.props.initialFilter))
      if (hasAccess([6], this.props.auth.user.UserType)) {
        newFilter.process.draft2 = false
        newFilter.process.draft1 = false
        newFilter.process.draft = false
        newFilter.process.Completed = false
        newFilter.process.CompletedThisWeek = true
        newFilter.customergroup = {}
        newFilter.pricemodel = {}
        window.localStorage.setItem('get-drafts-as-wp', 'false')
      }
      this.props.onSubmit(newFilter)
    }, 50)
    let filter = { ...this.state.filter }
    if (hasAccess([6], this.props.auth.user.UserType)) {
      filter.process.draft2 = false
      filter.process.draft1 = false
      filter.process.draft = false
      filter.process.Completed = false
      filter.process.CompletedThisWeek = true
      filter.customergroup = {}
      filter.pricemodel = {}
      window.localStorage.setItem('get-drafts-as-wp', 'false')
      this.setState({
        filter: filter,
        selectedpricemodel: -1,
        selectedcustomergroup: -1
      }, () => {
        // console.log('reset filter', filter, this.state.filter)
      })
    }
    if (!hasAccess([4, 6], this.props.auth.user.UserType)) {
      this.setState({
        filter: {
          filter,
          process: {
            ...filter.process,
            Completed: false,
            CompletedThisWeek: true
          }
        }
      })
    }
  }

  resetSimplesearch (e) {
    if (e !== undefined) e.preventDefault()
    this.props.resetSimplesearch(this.props.source)
    this.refs.simplesearch.refs.input.value = ''
    setTimeout(() => {
      let newFilter = JSON.parse(JSON.stringify(this.props.initialFilter))
      this.props.onSubmit(newFilter)
    }, 50)
  }

  renderDepartmentType () {
    // let paintImage = 'blue'
    // let bodyImage = 'blue'
    let paintActive = ''
    let bodyActive = ''

    if (this.state.filter.HasPaintWork) {
      // paintImage = 'white1'
      paintActive = 'active'
    }
    if (this.state.filter.HasBodyWork) {
      // bodyImage = 'white'
      bodyActive = 'active'
    }

    const clicked = (val) => {
      this.setState({
        filter: {
          ...this.state.filter,
          [val]: !this.state.filter[val]
        }
      })
    }
    return (
      <Inline block fillChildNum={[0, 1]} alignChildren={'center'}>
        <div className={paintActive + ' paint'}>
          <Check onClick={clicked.bind(this, 'HasPaintWork')} checked={this.state.filter.HasPaintWork} labelText={(<Icon icon={OrderDepartmentIcons.Paint} />)} />
        </div>
        <div className={bodyActive + ' body'}>
          <Check onClick={clicked.bind(this, 'HasBodyWork')} checked={this.state.filter.HasBodyWork} labelText={(<Icon icon={OrderDepartmentIcons.Body} />)} />
        </div>
      </Inline>
    )
  }

  renderFilterOrdersAssignedToMe () {
    if (!hasAccess([3], this.props.auth.user.UserType)) return null   // Show only for employees.

    const onSwitch = () => {
      this.setState({
        filter: {
          ...this.state.filter,
          AssignedToMe: !this.state.filter.AssignedToMe
        }
      })
    }

    // console.log('SearchFilter -> renderFilterOrdersAssignedToMe: this.state.filter', this.state.filter.AssignedToMe, 'this.props', this.props)

    return (
      <div className='my-assigned-orders'>
        <Switch name='AssignedToMe' labelText={18259} checked={this.state.filter.AssignedToMe} onChange={onSwitch} />
      </div>
    )
  }

  render () {
    // console.log('SearchFilter -> render()', this.state.filter)
    if (this.state.filter === undefined || this.state.filter === null || typeof this.state.filter.delivery === 'undefined') {
      return <div />
    }

    let openClassname = ''
    let filterBackdrop = ''
    if (this.state.isOpen) {
      openClassname += 'open'
      filterBackdrop = <div className='backdrop__search' onClick={this.triggerSearch} />
    }

    return (
      <div>
        {filterBackdrop}
        <i className='responsiveSearchTrigger fa fa-search' onClick={this.triggerSearch} />
        <ul className={'filter__search ' + openClassname}>
          <form className='search--input'>
            <Text ref='simplesearch' name='simplesearch' />
            <Button labelText={translation('906')} onClick={this.simpleSearchForm} style='link' />
            <a onClick={this.resetSimplesearch.bind(this)}>{translation('13001')}</a>
          </form>

          <form onSubmit={this.advancedSearchForm}>
            <div className='head'>
              <h3>{translation('13389')}</h3>
            </div>
            {this.renderFilterOrdersAssignedToMe()}
            {!hasAccess([6], this.props.auth.user.UserType) && this.props.auth.departmentType !== 0 && (
              this.renderDepartmentType()
            )}
            {this.renderProcessStep()}
            {hasSubscriptionPermission(this.props.auth, 10, 25) && this.renderEvaluation()}
            {hasSubscriptionPermission(this.props.auth, 0, 4) && this.renderUpdate()}
            {hasAccess([6], this.props.auth.user.UserType) && this.renderEconomicFilter()}
            {this.renderAdditionalReport()}
            {hasSubscriptionPermission(this.props.auth, 10, 6) && this.renderInvoice()}
            {this.props.auth.departmentType !== 0 && (
              this.renderSpareParts()
            )}
            {hasAccess([6], this.props.auth.user.UserType) && this.renderPriceModel()}
            {hasAccess([6], this.props.auth.user.UserType) && this.renderCustomerGroup()}
            {this.renderOrderType()}
            {this.renderIdentification()}
            {this.renderDelivery()}
            {this.renderVehicleData()}
            {this.renderColor()}
            <div className='filter__search__bottom'>
              <Button labelText={translation('1228')} style='link' />
              <a onClick={this.resetFilter}>{translation('13498')}</a>
            </div>
          </form>
        </ul>
      </div>
    )
  }

}

SearchFilter.propTypes = {
  setOrdersFilter: PropTypes.func.isRequired,
  resetFilter: PropTypes.func.isRequired
}

function mapStateToProps (state) {
  let initialFilter = state.orders.initialFilterOrderlist
  let filter = state.orders.filterOrderlist
  let simplesearch = state.orders.simplesearch
  // console.log('Selected default initial filter', filter.AssignedToMe)
  if (hasAccess([4], state.auth.user.UserType)) {
    initialFilter = state.orders.initialFilterCustomer
    filter = state.orders.filterCustomer
    // console.log('Selected customer initial filter', filter.AssignedToMe)
  } else if (hasAccess([6], state.auth.user.UserType)) {
    initialFilter = state.orders.initialFilterWP
    filter = state.orders.filterWP
    // console.log('Selected wp initial filter', filter.AssignedToMe)
  } else if (state.routing.locationBeforeTransitions.pathname === '/workscreen') {
    initialFilter = state.orders.initialFilterWorkscreen
    filter = state.orders.filterWorkscreen
    simplesearch = state.orders.simplesearchWorkscreen
    // console.log('Selected workscreen initial filter', filter.AssignedToMe)
  }
  return {
    filter: filter,
    initialFilter: initialFilter,
    auth: state.auth,
    orderTypes: state.common.enums.orderTypes,
    simplesearch: simplesearch
  }
}
export default connect(mapStateToProps, {
  setOrdersFilter,
  resetFilter,
  getAgreementConstraints,
  getCustomerGroups,
  resetSimplesearch,
  setSimplesearch,
  setOrdersSearch
}, null, { withRef: true })(SearchFilter)



// WEBPACK FOOTER //
// ./src/app/shared/components/Search/SearchFilter/index.js